import requester from '@/utils/request'

export interface TelegramBotDetail {
  bindStatus: number
  createTime: number
  deleted: number
  email: string
  id: number
  startCode: string
  tgChatId: string
  tgUsername: string
  updateTime: number
  userCode: string
}

export const telegramService = {
  sendSecurityCheckEmail: (email: string) => requester.post('/event/telegram/sendSecurityCheckEmail', { email }),
  confirmSecurityCode: (data: { securityCode: string }) => requester.post('/event/telegram/confirmSecurityCode', data),
  queryTelegramBot: () => requester.post('/event/telegram/queryBindTelegram'),
  queryTelegramBotLink: () => requester.post('/event/telegram/queryBotLink'),

  // 获取任务列表 task/find-task
  queryTaskList: () => requester.post('/task/find-task', {}),
  // 分享到X的任务
  shareX: () => requester.post('/task/share-x', {}),
  // 分享到X的帖子
  sharePostX: () => requester.post('/task/share-x', {}),
  // 绑定校验是否需要提示
  userRevenueFlowCheckConsume: () => requester.post('/user/revenue/flow/check-consume', {}),
}
